import React, {Component} from "react";
import { connect } from 'react-redux';
import RoomCard from "./room_card.js";
import OnlinePrivateRooms from "../online-private-rooms/online-private-rooms.js";
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import "./online-room-list.css";

import {getRoomList} from "../../../modules/restore_together";



class OnlineRoomList extends Component {
    //expecting the user token to be part of the props object

    componentDidMount() {
        const {dispatch} = this.props;
        console.log("GETTING ROOM LIST!");
        dispatch(getRoomList());
    }

    printRoomPage(page) {
        let {token} = this.props;
        return <div key='room_page' className='room_page'>
            {page.map(function(room, i) {
                return <RoomCard key={i} room_data={room} token={token} />;
            })}
        </div>
    }

    printRooms() {
        let that = this;
        let {roomList} = this.props;
        const PAGE_SIZE = 3;

        let pages = [];

        let page = 0;
        for (var i = 0; i < roomList.length; i++) {
            let currentRoom = roomList[i];
            if (i % PAGE_SIZE === 0) {
                page++;
            }

            if (!pages[page]) {
                pages[page] = [];
            }

            pages[page].push(currentRoom);
        }

        return pages.map(function(page) {
            return that.printRoomPage(page);
        });
    }

    render() {
        const {token, roomList} = this.props;
        const gotRooms = roomList && roomList.length > 0 ? true : false;
        return (
            <div id='online_game_list_container'>
                <div className='online_game_list_title'>RESTORE-Together</div>
                <div id='online_game_list'>
                    <OnlinePrivateRooms token={token}/>
                    {gotRooms && 
                    <div className='online_rooms_container'>
                        <AwesomeSlider organicArrows={true} infinite={false} bullets={false} className='game_card_slider'>
                            {this.printRooms()}                    
                        </AwesomeSlider>
                    </div>
                    }
                    
                </div>
            </div>
        )
    }    
}

const withState = connect((state)=>{
    const { restoreTogether, user } = state;
    return{ 
        roomList: restoreTogether.roomList,
        token: user.token
    }
})

export default withState(OnlineRoomList)



// WEBPACK FOOTER //
// ./src/components/containers/online-room-list/online-room-list.js